import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentConfirmed = () => {
  const [stage, setStage] = useState(0);
  const Navigate=useNavigate();

  useEffect(() => {
    const timers = [
      setTimeout(() => setStage(1), 200),
      setTimeout(() => setStage(2), 500),
      setTimeout(() => setStage(3), 800),
    ];

    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4 relative overflow-hidden">

  {/* Soft background shapes */}
  <div className="absolute top-0 left-0 w-96 h-96 bg-purple-100 rounded-full blur-3xl opacity-60" />
  <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-100 rounded-full blur-3xl opacity-60" />

  {/* Success Card */}
  <div
    className={`relative bg-white border border-gray-100 rounded-3xl max-sm:!px-5 p-10 w-full max-w-md text-center shadow-xl transition-all duration-700 ${
      stage >= 1
        ? "opacity-100 translate-y-0"
        : "opacity-0 translate-y-6"
    }`}
  >
    {/* Checkmark */}
    <div className="relative flex justify-center mb-6">
      <div
        className={`w-24 h-24 rounded-full bg-[#00b300] flex items-center justify-center shadow-lg transition-all duration-500 ${
          stage >= 2
            ? "scale-100 opacity-100"
            : "scale-50 opacity-0"
        }`}
      >
        <svg
          className="w-12 h-12 text-white"
          viewBox="0 0 52 52"
        >
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="48"
            strokeDashoffset={stage >= 2 ? 0 : 48}
            className="transition-all duration-700 ease-out"
            d="M14 27l7 7 16-16"
          />
        </svg>
      </div>

      {stage >= 2 && (
        <div className="absolute w-24 h-24 rounded-full border-4 border-green-300 animate-ping opacity-20" />
      )}
    </div>

    {/* Title */}
    <h1
      className={`text-2xl font-bold text-gray-900 mb-3 transition-all duration-700 ${
        stage >= 2
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-4"
      }`}
    >
      Payment Successful
    </h1>

    {/* Subtitle */}
    <p
      className={`text-gray-500 text-md transition-all duration-700 delay-100 ${
        stage >= 3
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-4"
      }`}
    >
      Thank you for your payment. Your transaction has been completed successfully.
    </p>

    {/* Divider */}
    <div
      className={`mt-5 mb-5 h-px bg-gray-200 transition-all duration-700 ${
        stage >= 3
          ? "opacity-100 scale-x-100"
          : "opacity-0 scale-x-0"
      }`}
    />

    {/* Button */}
    <button
      className={`w-full bg-gradient-to-br from-[#115B9D] to-[#116DAE] text-white px-8 py-3 rounded-full shadow hover:scale-[1.04] duration-300 transition ${
        stage >= 3
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-4"
      }`}
      onClick={() => Navigate("/dashboard")}
    >
      Go to Dashboard
    </button>
  </div>
</div>
  );
};

export default PaymentConfirmed;
